function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 66 42"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M58.736 17.257V9.98h-5.189v7.277h-7.472v5.198h7.472v7.486h5.189v-7.486H66v-5.198h-7.264zm-37.774-.415v8.316s8.054-.01 11.333-.01c-1.776 5.391-4.537 8.327-11.333 8.327-6.877 0-12.245-5.585-12.245-12.475S14.085 8.525 20.962 8.525c3.636 0 5.985 1.28 8.139 3.065 1.724-1.728 1.58-1.974 5.967-6.124A20.865 20.865 0 0020.962 0C9.385 0 0 9.402 0 21s9.385 21 20.962 21c17.305 0 21.535-15.095 20.132-25.158H20.962z",
  fillRule: "evenodd"
}));